import { render, staticRenderFns } from "./OnlyOne.vue?vue&type=template&id=67ca4b54&scoped=true"
import script from "./OnlyOne.vue?vue&type=script&lang=ts"
export * from "./OnlyOne.vue?vue&type=script&lang=ts"
import style0 from "./OnlyOne.vue?vue&type=style&index=0&id=67ca4b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ca4b54",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShowGalleryImageWrapper: require('/usr/src/nuxt-app/components/show/gallery/ImageWrapper.vue').default})
